import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { CandidateHomeNew } from './modules/candidate-new/pages/candidate-home-new/candidate-home';
import CandidateInterviewNew from './modules/candidate-new/pages/candidate-interview-new/candidate-interview-new';
import CandidateResponseInterview from './modules/candidate-new/pages/candidate-response-interview-new/candidate-response-interview';
import { GtmInjection } from './modules/candidate/components/gtm-injection';
import { LayoutCandidateQuiz } from './modules/candidate/components/layot-candidate-quiz';
import { LayoutCandidate } from './modules/candidate/components/layout-candidate';
import { QuizProfileProvider } from './modules/candidate/components/quiz-profile/context/QuizContext';
import QuizProfile from './modules/candidate/components/quiz-profile/quiz-profile';
import { LinkExpirado } from './modules/candidate/pages/johari/LinkExpirado';
import { StepProvider } from './modules/candidate/pages/johari/context/StepContext';
import { Johari } from './modules/candidate/pages/johari/johari';
import { Result } from './modules/candidate/pages/johari/result';
import { ResultFail } from './modules/candidate/pages/johari/result-fail';
import ResultFailQuiz from './modules/candidate/pages/quiz/result-fail';
import ResultSucess from './modules/candidate/pages/quiz/result-success';
import Report from './modules/candidate/pages/report/report';
import ReportDetail from './modules/candidate/pages/report/report-detail/report-detail';
import Index from './modules/landing-page';
import Detail from './modules/landing-page/detail';
import { FormProvider } from './modules/landing-page/hook/form-context';
import { managerNewPaths } from './modules/manager-new/routes';
import { Layout } from './modules/manager/components/layout';
import { managerLegacyPaths } from './modules/manager/routes';
import { ShowContentManageClassProvider } from './modules/manager/context/content-context';
import { TableInterviewProvider } from './modules/manager/context/table-interview-context';
import { AmeiManagement } from './modules/manager/pages/amei-management/amei-management';
import { Candidates } from './modules/manager/pages/candidates/candidates';
import { AvaliableRuralProvider } from './modules/manager/pages/candidates/context/avaliable-rural-candidate';
import { NewClassRoomProvider } from './modules/manager/pages/candidates/context/new-class-room-context';
import { SeeAnswersNotesProvider } from './modules/manager/pages/candidates/context/see-answers-notes-context';
import { ManagerHome } from './modules/manager/pages/manager-home';
import { Settings } from './modules/manager/pages/settings/settings';
import { InterviewProvider } from './modules/shared/context/interview-context';
import { TableParticipantsProviderNew } from './modules/shared/context/table-participants-context-new';
import { ValidationsProvider } from './modules/shared/context/validations-context';
import { HomePage } from './modules/shared/pages/home-page/home-page';

const ModuleValidator = React.lazy(() =>
  import('./utils/validators/module-validator'),
);



const ManagerNewLayout = React.lazy(() =>
  import('./modules/manager-new/components/manager-layout-wrapper/manager-layout-wrapper'),
);

const ManageClass = React.lazy(() =>
  import('./modules/manager-new/pages/manage-class/manage-class'),
);
const ManageParticipants = React.lazy(() =>
  import('./modules/manager-new/pages/manage-participants/manage-participants'),
);
const ClassDetail = React.lazy(() =>
  import('./modules/manager-new/pages/class-detail/class-detail'),
);
const SelectionQuestionnaire = React.lazy(() =>
  import('./modules/manager-new/pages/selection-questionnaire/selection-questionnaire'),
);
const RuralScores = React.lazy(() =>
  import('./modules/manager-new/pages/rural-scores/rural-scores'),
);
const SettingsNew = React.lazy(() =>
  import('./modules/manager-new/pages/settings/settings').then((m) => ({
    default: m.Settings,
  })),
);

const ClassDetailWithParticipants = () => {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  return (
    <TableParticipantsProviderNew idTurma={getRouteParam('id')}>
      <ClassDetail />
    </TableParticipantsProviderNew>
  );
};

const LEGACY_ONLY_PARAMS = ['manageRegional', 'interview'];

const InterviewRedirect = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pathname = LEGACY_ONLY_PARAMS.some((param) => params.has(param))
    ? managerLegacyPaths.entrevista
    : managerNewPaths.participantes;

  return <Redirect to={{ pathname, search }} />;
};


const routesGestorNew = () => {
  return [
    {
      routePath: `${managerNewPaths.turmaDetalhe}/:id`,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <ClassDetailWithParticipants />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
    {
      routePath: managerNewPaths.turmas,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <ManageClass />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
    {
      routePath: managerNewPaths.participantes,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <ManageParticipants />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
    {
      routePath: `${managerNewPaths.questionarioSelecao}/:id`,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <SelectionQuestionnaire />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
    {
      routePath: `${managerNewPaths.notasCce}/:id`,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <RuralScores />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
    {
      routePath: managerNewPaths.configuracoes,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR'],
      orRedirectTo: managerNewPaths.turmas,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ManagerNewLayout>
            <SettingsNew />
          </ManagerNewLayout>
        </React.Suspense>
      ),
    },
  ];
};


const routesGestor = () => {
  return [
    {
      routePath: '/',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <HomePage />
        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor/validate/:token',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ShowContentManageClassProvider>
            <NewClassRoomProvider>
              <ManagerHome />
            </NewClassRoomProvider>
          </ShowContentManageClassProvider>

        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ShowContentManageClassProvider>
            <NewClassRoomProvider>
              <ManagerHome />
            </NewClassRoomProvider>
          </ShowContentManageClassProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor/entrevista',
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: <InterviewRedirect />,
    },
    {
      routePath: managerLegacyPaths.entrevista,
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout showFooter>
              <NewClassRoomProvider>
                <SeeAnswersNotesProvider>
                  <Candidates />
                </SeeAnswersNotesProvider>
              </NewClassRoomProvider>
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },

    {
      routePath: '/gestor/configuracoes',
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout>
              <Settings />
              {/* <CalibrateNotes /> */}
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor/amei',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout>
              <AmeiManagement />
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },
  ];
};

const routesQuizProfile = () => {
  // candidato/questionario/perfil?module=1&interview=2
  return [
    {
      routePath: '/candidato/questionario/perfil/interview',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <QuizProfile />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/questionario/perfil/interview/sucesso',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <ResultSucess />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/questionario/perfil/interview/falha',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <ResultFailQuiz />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },
  ];
};

const routesCandidateNew = () => {
  return [
    {
      routePath: '/candidato',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <CandidateHomeNew />
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/sobre-curso',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateInterviewNew />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/avaliacao',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateResponseInterview />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/interview',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateInterviewNew />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    //rotas acessadas pelo ADMINISTRADOR
    {
      routePath: '/candidato/id/:id',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateHomeNew />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/sobre-curso/id/:id',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateInterviewNew />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/avaliacao/id/:id',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <InterviewProvider>
              <ValidationsProvider>
                <CandidateResponseInterview />
              </ValidationsProvider>
            </InterviewProvider>
          </GtmInjection>
        </React.Suspense>
      ),
    },
  ];
};
// const routesCandidate = () => {
//   return [
//     {
//       routePath: '/',
//       isExactPath: true,
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <CandidateHome />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//     {
//       routePath: '/candidato',
//       orRedirectTo: '/',
//       isExactPath: true,
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <CandidateInterview />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },

//     {
//       routePath: '/candidato/sobre-curso',
//       isExactPath: true,
//       ifIsAuthenticated: true,
//       orRedirectTo: '/',
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <AboutCourse />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//     {
//       routePath: '/candidato/resultado',
//       isExactPath: true,
//       ifIsAuthenticated: true,
//       orRedirectTo: '/',
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <ResultContent />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//     //rotas acessadas pelos adm
//     {
//       routePath: '/candidato/id/:id',
//       isExactPath: true,
//       orRedirectTo: '/',
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <CandidateInterview />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//     {
//       routePath: '/candidato/sobre-curso/id/:id',
//       isExactPath: true,
//       ifIsAuthenticated: true,
//       orRedirectTo: '/',
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <AboutCourse />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//     {
//       routePath: '/candidato/resultado/id/:id',
//       isExactPath: true,
//       ifIsAuthenticated: true,
//       orRedirectTo: '/candidato',
//       pageToRender: (
//         <React.Suspense fallback={<BaSeLoadingPage />}>
//           <GtmInjection>
//             <ResultContent />
//           </GtmInjection>
//         </React.Suspense>
//       ),
//     },
//   ];
// };

const routesJohari = () => {
  return [
    {
      routePath: '/candidato/questionario',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Johari />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/:module/questionario/:cpf',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Johari />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/link-expirado',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LinkExpirado />
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/resultado',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Result />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/resultado/falhou',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <ResultFail />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
  ];
};

const routesRelatorio = () => {
  return [
    {
      routePath: '/relatorio',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <Report />
        </React.Suspense>
      ),
    },
    {
      routePath: '/relatorio/:cpf',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ReportDetail />
        </React.Suspense>
      ),
    },
  ];
};

const routesApresentation = () => {
  return [
    {
      routePath: '/portal',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <FormProvider>
            <Index />
          </FormProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/portal/modulo/:module',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <FormProvider>
            <Detail />
          </FormProvider>
        </React.Suspense>
      ),
    },
  ];
};

export const Routes = () => (
  <TableInterviewProvider>
    <AvaliableRuralProvider>
      <Sebrae.Routes
        routes={[
          ...routesApresentation(),
          ...routesRelatorio(),
          ...routesGestor(),
          // ...routesCandidate(),
          ...routesJohari(),
          ...routesQuizProfile(),
          ...routesCandidateNew(),
          ...routesGestorNew()
        ]}
      />
    </AvaliableRuralProvider>
  </TableInterviewProvider >
);
